
export default "/assets/chat-bubble-left-right-mini.6bd1247c.svg"